

import React from 'react';

import { SizeMe } from 'react-sizeme';
import CreditsOverviewComponent from '../components/CreditsOverview';









function CreditsOverview(props) {
  return (
    <SizeMe>
      {({ size }) => <CreditsOverviewComponent size={size} {...props} />}
    </SizeMe>);

}

export default CreditsOverview;